import { render } from "./speech-bubble.vue?vue&type=template&id=5ddd5f11&ts=true"
import script from "./speech-bubble.vue?vue&type=script&lang=ts"
export * from "./speech-bubble.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__